const NOMINATIM_BASE_URL = "https://nominatim.openstreetmap.org/reverse";

export interface NominatimReverseResult {
  display_name: string;
  address?: Record<string, string>;
}

/**
 * Reverse-geocode a lat/lng coordinate using the Nominatim API.
 * Returns the parsed response or null on network/parse failure.
 */
export async function reverseGeocode(
  lat: number,
  lng: number,
): Promise<NominatimReverseResult | null> {
  try {
    const res = await fetch(
      `${NOMINATIM_BASE_URL}?lat=${lat}&lon=${lng}&format=json`,
      { headers: { "Accept-Language": "en" } },
    );
    const data = (await res.json()) as NominatimReverseResult;
    return data;
  } catch {
    return null;
  }
}
